import { makeNetTerms } from '~/infra/translator';
import { assertUnreachable } from '~/infra/utils';
export var AmendmentDraftChangeType = /*#__PURE__*/ function(AmendmentDraftChangeType) {
    AmendmentDraftChangeType["ServiceCost"] = "serviceCostChange";
    AmendmentDraftChangeType["NetTerms"] = "netTermsChange";
    AmendmentDraftChangeType["ServiceName"] = "serviceNameChange";
    AmendmentDraftChangeType["ServiceDescription"] = "serviceDescriptionChange";
    AmendmentDraftChangeType["ServiceTermsUpdated"] = "serviceTermsUpdatedChange";
    AmendmentDraftChangeType["ServiceTermsRemoved"] = "serviceTermsRemovedChange";
    AmendmentDraftChangeType["ServiceBilledUpon"] = "serviceBilledUponChange";
    AmendmentDraftChangeType["ServiceBundle"] = "serviceBundleChange";
    AmendmentDraftChangeType["ServiceAdded"] = "serviceAddedChange";
    AmendmentDraftChangeType["ServiceTerminated"] = "serviceTerminatedChange";
    AmendmentDraftChangeType["ServiceCanceled"] = "serviceCanceledChange";
    AmendmentDraftChangeType["ServiceIntegratedClass"] = "serviceIntegratedClassChange";
    AmendmentDraftChangeType["ManualPayments"] = "manualPaymentsChange";
    AmendmentDraftChangeType["CoverCreditCardFees"] = "coverCreditCardFeesChange";
    AmendmentDraftChangeType["LegalTermsDocuments"] = "legalTermsDocumentsChange";
    AmendmentDraftChangeType["AmendmentsApprovalMethod"] = "amendmentsApprovalMethodChange";
    AmendmentDraftChangeType["InvoicesApprovalMethod"] = "invoicesApprovalMethodChange";
    AmendmentDraftChangeType["CustomPageAdded"] = "customPageAddedChange";
    AmendmentDraftChangeType["CustomPageUpdated"] = "customPageUpdatedChange";
    return AmendmentDraftChangeType;
}({});
export var LastModificationType = /*#__PURE__*/ function(LastModificationType) {
    LastModificationType["NeverModified"] = "neverModified";
    LastModificationType["Modified"] = "modified";
    return LastModificationType;
}({});
export const neverModified = ()=>({
        type: "neverModified"
    });
export const modifiedBy = (modified)=>({
        type: "modified",
        modified
    });
export const lastModificationFromDTO = (dto)=>dto !== null && dto !== void 0 ? dto : neverModified();
export const modificationRecordOf = (lastModification)=>lastModification.type === "modified" ? lastModification.modified : undefined;
export function acceptAmendmentDraftChange(change, visitor) {
    switch(change.type){
        case "serviceCostChange":
            var _visitor_visitServiceCost;
            return (_visitor_visitServiceCost = visitor.visitServiceCost) === null || _visitor_visitServiceCost === void 0 ? void 0 : _visitor_visitServiceCost.call(visitor, change.value);
        case "netTermsChange":
            var _visitor_visitNetTerms;
            return (_visitor_visitNetTerms = visitor.visitNetTerms) === null || _visitor_visitNetTerms === void 0 ? void 0 : _visitor_visitNetTerms.call(visitor, change.value);
        case "serviceNameChange":
            var _visitor_visitServiceName;
            return (_visitor_visitServiceName = visitor.visitServiceName) === null || _visitor_visitServiceName === void 0 ? void 0 : _visitor_visitServiceName.call(visitor, change.value);
        case "serviceDescriptionChange":
            var _visitor_visitServiceDescription;
            return (_visitor_visitServiceDescription = visitor.visitServiceDescription) === null || _visitor_visitServiceDescription === void 0 ? void 0 : _visitor_visitServiceDescription.call(visitor, change.value);
        case "serviceTermsUpdatedChange":
            var _visitor_visitServiceTermsUpdated;
            return (_visitor_visitServiceTermsUpdated = visitor.visitServiceTermsUpdated) === null || _visitor_visitServiceTermsUpdated === void 0 ? void 0 : _visitor_visitServiceTermsUpdated.call(visitor, change.value);
        case "serviceTermsRemovedChange":
            var _visitor_visitServiceTermsRemoved;
            return (_visitor_visitServiceTermsRemoved = visitor.visitServiceTermsRemoved) === null || _visitor_visitServiceTermsRemoved === void 0 ? void 0 : _visitor_visitServiceTermsRemoved.call(visitor, change.value);
        case "serviceBilledUponChange":
            var _visitor_visitServiceBilledUpon;
            return (_visitor_visitServiceBilledUpon = visitor.visitServiceBilledUpon) === null || _visitor_visitServiceBilledUpon === void 0 ? void 0 : _visitor_visitServiceBilledUpon.call(visitor, change.value);
        case "serviceBundleChange":
            var _visitor_visitServiceBundle;
            return (_visitor_visitServiceBundle = visitor.visitServiceBundle) === null || _visitor_visitServiceBundle === void 0 ? void 0 : _visitor_visitServiceBundle.call(visitor, change.value);
        case "serviceAddedChange":
            var _visitor_visitServiceAdded;
            return (_visitor_visitServiceAdded = visitor.visitServiceAdded) === null || _visitor_visitServiceAdded === void 0 ? void 0 : _visitor_visitServiceAdded.call(visitor, change.value);
        case "serviceTerminatedChange":
            var _visitor_visitServiceTerminated;
            return (_visitor_visitServiceTerminated = visitor.visitServiceTerminated) === null || _visitor_visitServiceTerminated === void 0 ? void 0 : _visitor_visitServiceTerminated.call(visitor, change.value);
        case "serviceCanceledChange":
            var _visitor_visitServiceCanceled;
            return (_visitor_visitServiceCanceled = visitor.visitServiceCanceled) === null || _visitor_visitServiceCanceled === void 0 ? void 0 : _visitor_visitServiceCanceled.call(visitor, change.value);
        case "serviceIntegratedClassChange":
            var _visitor_visitServiceIntegratedClass;
            return (_visitor_visitServiceIntegratedClass = visitor.visitServiceIntegratedClass) === null || _visitor_visitServiceIntegratedClass === void 0 ? void 0 : _visitor_visitServiceIntegratedClass.call(visitor, change.value);
        case "manualPaymentsChange":
            var _visitor_visitManualPayments;
            return (_visitor_visitManualPayments = visitor.visitManualPayments) === null || _visitor_visitManualPayments === void 0 ? void 0 : _visitor_visitManualPayments.call(visitor, change.value);
        case "coverCreditCardFeesChange":
            var _visitor_visitCoverCreditCardFees;
            return (_visitor_visitCoverCreditCardFees = visitor.visitCoverCreditCardFees) === null || _visitor_visitCoverCreditCardFees === void 0 ? void 0 : _visitor_visitCoverCreditCardFees.call(visitor, change.value);
        case "legalTermsDocumentsChange":
            var _visitor_visitLegalTermsDocuments;
            return (_visitor_visitLegalTermsDocuments = visitor.visitLegalTermsDocuments) === null || _visitor_visitLegalTermsDocuments === void 0 ? void 0 : _visitor_visitLegalTermsDocuments.call(visitor, change.value);
        case "amendmentsApprovalMethodChange":
            var _visitor_visitAmendmentsApprovalMethod;
            return (_visitor_visitAmendmentsApprovalMethod = visitor.visitAmendmentsApprovalMethod) === null || _visitor_visitAmendmentsApprovalMethod === void 0 ? void 0 : _visitor_visitAmendmentsApprovalMethod.call(visitor, change.value);
        case "invoicesApprovalMethodChange":
            var _visitor_visitInvoicesApprovalMethod;
            return (_visitor_visitInvoicesApprovalMethod = visitor.visitInvoicesApprovalMethod) === null || _visitor_visitInvoicesApprovalMethod === void 0 ? void 0 : _visitor_visitInvoicesApprovalMethod.call(visitor, change.value);
        case "customPageAddedChange":
            var _visitor_visitCustomPageAdded;
            return (_visitor_visitCustomPageAdded = visitor.visitCustomPageAdded) === null || _visitor_visitCustomPageAdded === void 0 ? void 0 : _visitor_visitCustomPageAdded.call(visitor, change.value);
        case "customPageUpdatedChange":
            var _visitor_visitCustomPageUpdated;
            return (_visitor_visitCustomPageUpdated = visitor.visitCustomPageUpdated) === null || _visitor_visitCustomPageUpdated === void 0 ? void 0 : _visitor_visitCustomPageUpdated.call(visitor, change.value);
        default:
            return assertUnreachable(change);
    }
}
export const makeServiceCostChange = (serviceId, cost)=>({
        type: "serviceCostChange",
        value: {
            serviceId,
            cost
        }
    });
export const makeNetTermsChange = (netTerms)=>({
        type: "netTermsChange",
        value: {
            netTerms: makeNetTerms(netTerms)
        }
    });
export const makeServiceNameChange = (serviceId, name)=>({
        type: "serviceNameChange",
        value: {
            serviceId,
            name
        }
    });
export const makeServiceDescriptionChange = (serviceId, description)=>({
        type: "serviceDescriptionChange",
        value: {
            serviceId,
            description
        }
    });
export const makeServiceTermsUpdatedChange = (serviceId, terms)=>({
        type: "serviceTermsUpdatedChange",
        value: {
            serviceId,
            terms
        }
    });
export const makeServiceTermsRemovedChange = (serviceId)=>({
        type: "serviceTermsRemovedChange",
        value: {
            serviceId
        }
    });
export const makeServiceBilledUponChange = (serviceId, billedUpon)=>({
        type: "serviceBilledUponChange",
        value: {
            serviceId,
            billedUpon
        }
    });
export const makeServiceBundleChange = (serviceId, bundle)=>({
        type: "serviceBundleChange",
        value: {
            serviceId,
            bundle
        }
    });
export const makeServiceAddedChange = (serviceId, service)=>({
        type: "serviceAddedChange",
        value: {
            serviceId,
            service
        }
    });
export const makeServiceTerminatedChange = (serviceId)=>({
        type: "serviceTerminatedChange",
        value: {
            serviceId
        }
    });
export const makeServiceCanceledChange = (serviceId)=>({
        type: "serviceCanceledChange",
        value: {
            serviceId
        }
    });
export const makeServiceIntegratedClassChange = (serviceId, integratedClass)=>({
        type: "serviceIntegratedClassChange",
        value: {
            serviceId,
            integratedClass
        }
    });
export const makeManualPaymentsChange = (allowManualPayments)=>({
        type: "manualPaymentsChange",
        value: {
            allowManualPayments
        }
    });
export const makeCoverCreditCardFeesChange = (coverCreditCardFees)=>({
        type: "coverCreditCardFeesChange",
        value: {
            coverCreditCardFees
        }
    });
export const makeLegalTermsDocumentsChange = (legalTermsDocuments)=>({
        type: "legalTermsDocumentsChange",
        value: {
            legalTermsDocuments
        }
    });
export const makeAmendmentsApprovalMethodChange = (amendmentsApprovalMethod)=>({
        type: "amendmentsApprovalMethodChange",
        value: {
            amendmentsApprovalMethod
        }
    });
export const makeInvoicesApprovalMethodChange = (invoicesApprovalMethod)=>({
        type: "invoicesApprovalMethodChange",
        value: {
            invoicesApprovalMethod
        }
    });
export const makeCustomPageAddedChange = (page)=>({
        type: "customPageAddedChange",
        value: {
            page
        }
    });
export const makeCustomPageUpdatedChange = (page)=>({
        type: "customPageUpdatedChange",
        value: {
            page
        }
    });
